import { render, staticRenderFns } from "./internalImprovementInfo.vue?vue&type=template&id=525887a4"
import script from "./internalImprovementInfo.vue?vue&type=script&lang=js"
export * from "./internalImprovementInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('525887a4')) {
      api.createRecord('525887a4', component.options)
    } else {
      api.reload('525887a4', component.options)
    }
    module.hot.accept("./internalImprovementInfo.vue?vue&type=template&id=525887a4", function () {
      api.rerender('525887a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/internalAudit/internalImprovementInfo.vue"
export default component.exports